import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownSelector, initializeMultipleSelectorState, reduceMultipleSelectorState, } from '@dossierhq/design';
import { AuthKeyTag } from '../AuthKeyTag/AuthKeyTag.js';
export function initializeAuthKeySelectorState({ authKeys, selectedIds, }) {
    const items = authKeys.map((it) => ({
        id: it.authKey,
        displayName: it.displayName,
    }));
    return initializeMultipleSelectorState({
        items,
        selectedIds,
    });
}
export const reduceAuthKeySelectorState = reduceMultipleSelectorState;
export function AuthKeySelector(props) {
    return (_jsx(DropdownSelector, { ...props, renderItem: (item) => _jsx(AuthKeyTag, { authKey: item.id, authKeys: props.authKeys }) }));
}
//# sourceMappingURL=AuthKeySelector.js.map